// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { LOCAL_STORAGE_THEME_KEY, getFromLocalStorage, saveToLocalStorage } from 'utils/localStorage';
import { PossibleThemeName } from './theme.types';

export const saveThemeNameToLocalStorage = (themeName: PossibleThemeName): void =>
  saveToLocalStorage(LOCAL_STORAGE_THEME_KEY, themeName);

export const getThemeNameFromLocalStorage = (): PossibleThemeName | undefined => {
  const localStorageValue = getFromLocalStorage(LOCAL_STORAGE_THEME_KEY);
  return localStorageValue ? ((localStorageValue as PossibleThemeName) === 'Dark' ? 'Dark' : 'Light') : undefined;
};
